/* global Intercom */
import React, { Component, PropTypes } from "react";
import { Link } from "react-router/es";
import { connect } from "react-redux";
import { createEvent } from "googleanalytics";
import { getThemesAsyncByDateAndOccasion } from "actions/themes";
import { resetDesignState } from "actions/design";
import { getRecipesCount } from "actions/recipes";
import { getMenusCount } from "actions/menus";
import { getDesignsCount } from "actions/designs";
import { getDashboardMeta } from "selectors/dashboard";
import { getCurrentUserBrand } from "selectors/user-brands";
import FlexContainer from "components/Layout/FlexContainer";
import FlexMenuRight from "components/Layout/FlexMenuRight";
import FlexContent from "components/Layout/FlexContent";
import AuthorizationHOC from "components/HOC/AuthorizationHOC";
import ValidationLegalHOC from "components/HOC/ValidationLegalHOC";
import BrandInfo from "components/BrandInfo";
import moment from "moment";
import LoadingIndicator from "components/LoadingIndicator";
import { routeCodes, subRouteCodes, routeParams } from "constants/routes";
import { updateDesign } from "actions/design";
import { CATEGORIES, ACTIONS } from "constants/googleAnalytics";

import { COLLAPSIBLES } from "constants/collapsibles";
import { removeCollapsible } from "actions/collapsibles";
import { resetseasonalFlowDesignTemplatesState } from "actions/seasonalFlowDesignTemplates";
import { resetuseItAgainDesignTemplatesState } from "actions/useItAgainDesignTemplates";
import { resetfoodTypeDesignTemplatesState } from "actions/foodTypeDesignTemplates";
import { resetcleanSimpleDesignTemplatesState } from "actions/cleanSimpleDesignTemplates";
import { resetupcomingOccaDesignTemplatesState } from "actions/upcomingOccaDesignTemplates";
import { resetcaterConcesDesignTemplatesState } from "actions/caterConcesDesignTemplates";
import { resettypeItemGalleriesState } from "actions/typeItemGalleries";
import { resetmainColorDesignTemplatesState } from "actions/mainColorDesignTemplates";
import { resetThemesGraphicCategoryState } from "actions/themesGraphicCategory";
import { resetThemesOccasionState } from "actions/themesOccasion";
import { resetenlargeViewDesignTemplatesState } from "actions/enlargeViewDesignTemplates";
import {
  updateGlobalParameter,
  resetGlobalParameterState,
} from "actions/globalParameter";
import {
  setGlobalPriceModalState,
  updateGlobalPrice,
  setGlobalPriceUpdateModalState,
} from "actions/globalPrice";
import { setNotificationCenterModalState } from "actions/notifications";
import { getSyscoProducts } from "actions/syscoProducts";

import Theme from "records/Theme";
import * as OpcoUtils from "records/OpcoUtils";
import GlobalPriceModal from "components/GlobalPriceModal";
import { ingredientTypeMap } from "constants/ingredientType";
import {
  getPriceEffectiveDate,
  isGlobalPriceEligible,
  shouldFetchSyscoProducts,
} from "helpers/globalPriceHelper";
import {
  GP_INITIAL_MODAL_HEADER,
  GP_INITIAL_MODAL_TEXT_DESCRIPTION1,
  GP_INITIAL_MODAL_TEXT_DESCRIPTION2,
} from "constants/globalPrice";
import {
  CLAIM_AND_VERIFICATION_PROCESS_FAILURE_MSG,
  LINK_LOCATION_FAILURE_MSG,
} from "constants/gbp";
import { fetchNotificationsAsync } from "actions/notifications";
import { getCurrentUserDetails } from "actions/user";
import GbpModal from "containers/Gbp";
import {
  setModalVisibility as setGbpModalVisibility,
  setGbpAlertVisibility,
  setGbpFailureAlertVisibility,
} from "actions/gbp";
import AlertModal from "components/AlertModal/AlertModal";
import Button from "muicss/lib/react/button";

import DashboardCard from "components/ThemeIndicator/DashboardCard";
import MFACenter from 'containers/MFACentre';


@connect((state) => ({
  dashboardMeta: getDashboardMeta(state),
  themes: state.themes.get("data"),
  currentBrand: getCurrentUserBrand(state),
  loading: state.themes.get("loading"),
  design: state.design.get("data"),
  globalParameter: state.globalParameter.get("data"),
  user: state.user.get("data"),
  syscoProducts: state.syscoProducts.get("data"),
  globalPrice: state.globalPrice,
  isGbpModalOpen: state.gbp.get("isModalOpen"),
  isGbpAlertModalOpen: state.gbp.get("isAlertModalOpen"),
  gbpFailureAlert: state.gbp.get("failureAlert"),
  isLinkLocationAlert: state.gbp.get("isLinkLocation"),
  stack: state.contentstack,
}))
class Dashboard extends Component {
  static propTypes = {
    dashboardMeta: PropTypes.object,
    currentBrand: PropTypes.object,
    themes: PropTypes.object,
    loading: PropTypes.bool,
    dispatch: PropTypes.func,
    design: PropTypes.object,
    globalParameter: PropTypes.object,
    user: PropTypes.object,
    syscoProducts: PropTypes.object,
    globalPrice: PropTypes.object,
    isGbpModalOpen: PropTypes.bool,
    isGbpAlertModalOpen: PropTypes.bool,
    stack: PropTypes.object,
  };

  constructor() {
    super();
    this.onLinkClick = this.onLinkClick.bind(this);
    this.onBrowseMoreThemes = this.onBrowseMoreThemes.bind(this);
  }

  componentWillMount() {
    const { dispatch, user } = this.props;
    var date = `${moment().format("YYYYMMDD")}`;
    dispatch(getRecipesCount());
    dispatch(getMenusCount("E"));
    dispatch(getDesignsCount());
    dispatch(getThemesAsyncByDateAndOccasion(date, true));

    dispatch(resetDesignState());
    dispatch(resetseasonalFlowDesignTemplatesState());
    dispatch(resetuseItAgainDesignTemplatesState());
    dispatch(resetfoodTypeDesignTemplatesState());
    dispatch(resetcleanSimpleDesignTemplatesState());
    dispatch(resetupcomingOccaDesignTemplatesState());
    dispatch(resetcaterConcesDesignTemplatesState());
    dispatch(resettypeItemGalleriesState());
    dispatch(resetmainColorDesignTemplatesState());
    dispatch(resetThemesGraphicCategoryState());
    dispatch(resetThemesOccasionState());
    dispatch(resetenlargeViewDesignTemplatesState());

    dispatch(resetGlobalParameterState());

    dispatch(removeCollapsible(COLLAPSIBLES.CANVAS_PAGE_OPTIONS.NAME));
    dispatch(removeCollapsible(COLLAPSIBLES.CANVAS_PAGE_OPTIONS_CONTENT.NAME));

  }

  onLinkClick(designThemeId) {
    const { router, dispatch, design, themes, globalParameter } = this.props;
    let newDesign = design.set("designThemeId", designThemeId);
    let oneThemeData = Theme.getThemeDataByTypeItemId(themes, designThemeId);
    let themeTitle =
      oneThemeData.size > 0 ? oneThemeData.first().get("typeItemName") : "";
    newDesign = newDesign.set("designThemeName", themeTitle);

    dispatch(updateDesign(newDesign));

    let newGlobalParas = globalParameter.set("designThemeId", designThemeId);
    dispatch(updateGlobalParameter(newGlobalParas));

    router.push(
      `${routeCodes.DESIGNS}${subRouteCodes.DESIGNS.MANAGE_DESIGN}/${routeParams.MANAGE_DESIGN.BACKGROUND}`
    );
  }


  onBrowseMoreThemes() {
    this.onLinkClick(99999);
  }

  /**
   * Show/Hide GMB modal upon the given value
   * If the visibility is undefined,
   * it will switch the previous state value
   * @param {Boolean} visibility should the modal be visible
   */
  setGmbModalVisibility = (visibility) =>
    this.props.dispatch(setGbpModalVisibility(visibility));

  setGlobalPriceModalVisibility = (isAfterGlobalPriceUpdate, isOpen) => {
    const { dispatch, user } = this.props;
    dispatch(setGlobalPriceModalState(isOpen));
    if (!isAfterGlobalPriceUpdate) {
      createEvent(
        CATEGORIES.GP,
        ACTIONS.NO_FOR_FIRST_TIME_COST_ROLLUP,
        `${user.get("opcoId")}-${user.get("syscoCustomerId")}`,
        user
      );
    }
  };

  updateGlobalPrice = () => {
    const { dispatch, user } = this.props;
    dispatch(updateGlobalPrice()).then(() => {
      dispatch(getCurrentUserDetails(user.getSyscoId()));
      dispatch(fetchNotificationsAsync());
      this.setNotificationCenterVisibility(true);
    });
    createEvent(
      CATEGORIES.GP,
      ACTIONS.FIRST_TIME_COST_ROLLUP,
      `${user.get("opcoId")}-${user.get("syscoCustomerId")}`,
      user
    );
  };

  setNotificationCenterVisibility = (isOpen) => {
    const { dispatch } = this.props;
    dispatch(setNotificationCenterModalState(isOpen));
  };

  closeGbpAlert = () => {
    const { dispatch } = this.props;
    dispatch(setGbpAlertVisibility(false));
  };

  onCloseFailureAlert = () => {
    const { dispatch } = this.props;
    dispatch(setGbpFailureAlertVisibility(false));
  };

  componentDidMount() {
    const { dispatch, user, currentBrand, syscoProducts } = this.props;

    const title = "Dashboard - Sysco Studio";
    window.history.replaceState(null, title, routeCodes.DASHBOARD);
    document.title = title;

    const priceEffectiveDate = getPriceEffectiveDate(currentBrand);

    if (!priceEffectiveDate && shouldFetchSyscoProducts(user, syscoProducts)) {
      dispatch(
        getSyscoProducts(
          currentBrand.get("id"),
          ingredientTypeMap.SYSCO_PRODUCTS
        )
      );
    }

    const cutOffDate = moment().subtract(6, "months").startOf("day");
    const priceEffDate = moment.utc(priceEffectiveDate).local();
    if (priceEffDate.isBefore(cutOffDate)) {
      dispatch(setGlobalPriceUpdateModalState(true));
    }

    window.intercomSettings = {
      app_id: APP_CONFIG.intercomId,
      name: user.firstName,
      email: user.emailAddress,
      created_at: Math.round(+new Date() / 1000),
      vertical_padding: 85,
    };
    Intercom("update", {
      hide_default_launcher: false,
    });
  }

  render() {
    const {
      dashboardMeta,
      currentBrand,
      loading,
      user,
      syscoProducts,
      globalPrice: { isInitialModalOpen },
      isGbpModalOpen,
      isGbpAlertModalOpen,
      gbpFailureAlert,
      isLinkLocationAlert,
      stack: { heroBanner, cardContainer, featureCallout },
    } = this.props;
    const disableDesigns = OpcoUtils.shouldCurrentOpcoSuppressed(user.opcoId);
    const disableTrendingCategories = disableDesigns;
    const priceEffectiveDate = getPriceEffectiveDate(currentBrand);

    return (
      <div>
        {heroBanner && !!heroBanner.background_image ? (
          <div
            className={"dashboard-hero-section flex items-center"}
            style={{
              background: `url(${heroBanner.background_image[0].url})`,
            }}
          >
            <div className={"dashboard-hero-content"}>
              <h2 className="hero-title">
                {heroBanner.heading_one}
                {heroBanner.logo_image && <img
                  alt={"sysco"}
                  className={"hero-sysco-logo"}
                  src={heroBanner.logo_image.url}
                /> }
                {heroBanner.heading_two && <div>{heroBanner.heading_two}</div>}
                
              </h2>
              {heroBanner.small_heading && <h2 className="hero-title">{heroBanner.small_heading}</h2>}
              <p className={"mui--text-light hero-description"}>{heroBanner.description}</p>
              <Link to={heroBanner.button.href} target="_blank">
                <Button className="mui-btn--secondary pure-white-button">
                  {heroBanner.button.title}
                </Button>
              </Link>
            </div>
          </div>
        ) : null}
        <FlexContainer>
          <FlexMenuRight>
            <BrandInfo
              featureCallout={featureCallout.cards}
              brand={currentBrand}
              user={user}
              changeGmbVisibility={this.setGmbModalVisibility}
              designs={dashboardMeta.designs}
              menus={dashboardMeta.menus}
              recipes={dashboardMeta.recipes}
            />
          </FlexMenuRight>
          <FlexContent>
              <LoadingIndicator loading={loading}>
                {cardContainer.cards ? (
                  <div className={"ad-space-cards"}>
                    {cardContainer.cards.map((card) => {
                      if (!card.hide_card) {
                        return (
                          <DashboardCard
                            key={card._metadata.uid}
                            themeHeadline={card.heading}
                            imgUrl={card.image[0].url}
                            displayName={card.description}
                            buttonText={card.button.title}
                            navlink={card.button.href}
                            newTab={card.open_link_in_new_tab}
                          />
                        );
                      }
                    })}
                  </div>
                ) : null}
              </LoadingIndicator>
          </FlexContent>
        </FlexContainer>
        {isGbpModalOpen ? <GbpModal /> : null}
        {!priceEffectiveDate && isGlobalPriceEligible(user, syscoProducts) ? (
          <GlobalPriceModal
            isModalOpen={isInitialModalOpen}
            changeVisibility={this.setGlobalPriceModalVisibility}
            changeNotificationCenterVisibility={
              this.setNotificationCenterVisibility
            }
            updateGlobalPrice={this.updateGlobalPrice}
            headerString={GP_INITIAL_MODAL_HEADER}
            descriptionString1={GP_INITIAL_MODAL_TEXT_DESCRIPTION1}
            descriptionString3={GP_INITIAL_MODAL_TEXT_DESCRIPTION2}
          />
        ) : null}
        {
          <AlertModal
            showAlert={isGbpAlertModalOpen && !isGbpModalOpen}
            alertMessage={"Google login failed. Please try again!"}
            onToggleAlertModal={this.closeGbpAlert}
          />
        }
        {!user.internal && user.mfaAlertedFlag != null && !user.mfaAlertedFlag ?
          <MFACenter isModalOpen={!user.mfaAlertedFlag} /> : null}
        <AlertModal
          showAlert={gbpFailureAlert}
          alertMessage={
            isLinkLocationAlert
              ? LINK_LOCATION_FAILURE_MSG
              : CLAIM_AND_VERIFICATION_PROCESS_FAILURE_MSG
          }
          onClose={this.onCloseFailureAlert}
        />
      </div>
    );
  }
}

export default AuthorizationHOC(ValidationLegalHOC(Dashboard));
